import { render } from "./LoadMore.vue?vue&type=template&id=47324cb6"
import script from "./LoadMore.vue?vue&type=script&lang=js"
export * from "./LoadMore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__